<script setup lang="ts">
import QitButton from "@/shared/components/buttons/qit-button.vue";

interface QitRouterLinkProps {
    /**
     * The target location to navigate to. Can be a string path or a route location object.
     */
    to: string | object;

    /**
     * The text label to display in the link.
     * @optional
     */
    label: string;

    /**
     * Whether to render the link with a button-style hover background effect.
     * When true, wraps the link content in a QitButton component.
     * @default false
     * @optional
     */
    hoverBackground?: boolean;
}
defineProps<QitRouterLinkProps>();
</script>

<template>
    <router-link :to="to" class="router-link">
        <template v-if="hoverBackground"><QitButton flat color="link" :label="label" /></template>
        <template v-else>{{ label }}</template>
    </router-link>
</template>
